/* Excella — uniform-height description tabs + Show more/less clamp (v2).
   Desktop tab panels get a shared min-height so switching tabs doesn't jump;
   any panel taller than the limit clamps with a fade + toggle button. */
(function(){
  'use strict';
  var LIMIT=520, BUFFER=90;
  var recs=[];

  function makeBtn(){
    var b=document.createElement('button');
    b.type='button'; b.className='exdc-toggle'; b.style.display='none';
    b.setAttribute('aria-expanded','false');
    b.innerHTML='<span class="exdc-lbl">Show full details</span>'+
      '<svg class="exdc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    return b;
  }

  function toggle(rec){
    var clip=rec.clip, btn=rec.btn;
    if(clip.classList.contains('exdc-collapsed')){
      clip.style.maxHeight=clip.scrollHeight+'px';
      clip.classList.remove('exdc-collapsed');
      btn.classList.add('exdc-open'); btn.setAttribute('aria-expanded','true');
      btn.querySelector('.exdc-lbl').textContent='Show less';
      setTimeout(function(){ clip.style.maxHeight='none'; }, 420);
    } else {
      clip.style.maxHeight=clip.scrollHeight+'px';
      requestAnimationFrame(function(){ clip.classList.add('exdc-collapsed'); clip.style.maxHeight=''; });
      btn.classList.remove('exdc-open'); btn.setAttribute('aria-expanded','false');
      btn.querySelector('.exdc-lbl').textContent='Show full details';
      setTimeout(function(){ rec.pane.scrollIntoView({behavior:'smooth',block:'start'}); }, 60);
    }
  }

  function initPane(pane, uniform){
    if(!pane || pane.__exdc) return; pane.__exdc=true;
    var clip=document.createElement('div');
    clip.className='exdc-clip'+(uniform?' exdc-uniform':'');
    while(pane.firstChild) clip.appendChild(pane.firstChild);
    pane.appendChild(clip);
    var btn=makeBtn(); pane.appendChild(btn);
    var rec={pane:pane, clip:clip, btn:btn, inited:false};
    btn.addEventListener('click',function(){ toggle(rec); });
    recs.push(rec);
  }

  function measure(rec){
    if(rec.pane.offsetParent===null) return false; /* hidden tab */
    var long=rec.clip.scrollHeight > LIMIT+BUFFER;
    if(!rec.inited){ if(long) rec.clip.classList.add('exdc-collapsed'); rec.inited=true; }
    rec.btn.style.display = long ? '' : 'none';
    if(!long) rec.clip.classList.remove('exdc-collapsed');
    return true;
  }
  function remeasure(){ for(var i=0;i<recs.length;i++) measure(recs[i]); }

  function setup(){
    var deskPanes=document.querySelectorAll('.description--tabs .tabs > [id^="tabs-"]');
    for(var i=0;i<deskPanes.length;i++) initPane(deskPanes[i], true);
    var mob=document.querySelector('#collapseOne .panel-body');
    if(mob) initPane(mob, false);
    if(!recs.length){
      initPane(document.querySelector('.description--tabs .grid__item.large--one-whole'), true);
    }
    remeasure();
    var tries=0;
    (function retry(){ remeasure(); if(tries++>28) return; setTimeout(retry,220); })();
    document.addEventListener('click',function(e){
      if(e.target.closest('.description--tabs')){
        setTimeout(remeasure,60); setTimeout(remeasure,300); setTimeout(remeasure,600);
      }
    });
    window.addEventListener('resize',function(){
      for(var i=0;i<recs.length;i++){
        var r=recs[i]; if(r.pane.offsetParent===null) continue;
        var long=r.clip.scrollHeight>LIMIT+BUFFER || r.clip.classList.contains('exdc-collapsed');
        r.btn.style.display=long?'':'none';
      }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup);
  else setup();
  window.addEventListener('load',setup);
})();
